import { ReviewSortEnum } from '@iheartjane/dm-sdk';
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';

import { useSDK } from '@jane/shared-ecomm/providers';

import type { ReviewSort } from '../reviewSort';

const REVIEWS_PAGE_SIZE = 5;

const SORT_TO_ENUM: Record<ReviewSort, ReviewSortEnum> = {
  rating: ReviewSortEnum.Rating,
  recent: ReviewSortEnum.Recent,
  upvote: ReviewSortEnum.Upvote,
};

type UseFetchProductReviewsProps = {
  activeActivities: string[];
  activeFeelings: string[];
  activeRatings: number[];
  enabled: boolean;
  hasComment?: boolean;
  pageSize?: number;
  productId: number;
  sort: ReviewSort;
};

export const useFetchProductReviews = ({
  activeActivities,
  activeFeelings,
  activeRatings,
  enabled,
  hasComment,
  pageSize = REVIEWS_PAGE_SIZE,
  productId,
  sort,
}: UseFetchProductReviewsProps) => {
  const { sdk, isReady } = useSDK();

  return useInfiniteQuery({
    enabled: !!sdk && isReady && enabled,
    queryKey: [
      'productReviews',
      'list',
      productId,
      sort,
      activeRatings,
      activeActivities,
      activeFeelings,
      pageSize,
      hasComment,
    ],
    queryFn: ({ pageParam }) =>
      sdk!.fetchProductReviews({
        activities: activeActivities.length ? activeActivities : undefined,
        feelings: activeFeelings.length ? activeFeelings : undefined,
        hasComment,
        page: pageParam,
        pageSize,
        productId,
        ratings: activeRatings.length ? activeRatings : undefined,
        sort: SORT_TO_ENUM[sort],
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.hasNextPage
        ? lastPage.pagination.currentPage + 1
        : undefined,
    placeholderData: keepPreviousData,
  });
};
